import Flickity from 'flickity';
import debounce from 'lodash/debounce';
import Layout from './Layout';
import TwitterFetcher from 'twitter-fetcher';
import jQuery from 'jquery';
export default class DynamicTwitterFeed {
    constructor(section) {
        this.$el = jQuery(section.el);
        this.$window = jQuery(window);
        this.flickity = null;
        this.$blogPosts = this.$el.find('[data-blog-posts]'); // Activate flickity on mobile
        this._mobileSlider = this._mobileSlider.bind(this);
        Layout.onBreakpointChange(this._mobileSlider);
        this._mobileSlider();
    }
    /**
     * Unbind events when section is re-drawn
     */
    onSectionUnload() {
        Layout.offBreakpointChange(this._mobileSlider);
        this._destroyFlickity();
    }
    _initFlickity() {
        this.flickity = new Flickity(this.$blogPosts[0], {
            cellSelector: '.article--excerpt-wrapper',
            contain: true,
            freeScroll: true,
            percentPosition: false,
            prevNextButtons: false,
            pageDots: false,
            setGallerySize: false,
        });
        this._bindSlider();
    }
    _destroyFlickity() {
        var _a;
        if (!this.flickity) {
            return;
        }
        this.$window.off('.blog-posts');
        this.$blogPosts.off('.blog-posts');
        (_a = this.flickity) === null || _a === void 0 ? void 0 : _a.destroy();
        this.flickity = null;
    }
    _mobileSlider() {
        // If is Large layout, attempt to destroy flickity
        if (Layout.isGreaterThanBreakpoint('M')) {
            this._destroyFlickity();
            return;
        } // Is XS/S/M, and flickity is init'd -- do nothing
        if (this.flickity) {
            return;
        } // Is XS/S/M, and flickity is not init'd
        this._initFlickity();
    }
    _bindSlider() {
        var _a;
        const $slider = this.$blogPosts.find('.flickity-slider');
        this.$window.on('resize.blog-posts', debounce(() => {
            this.$blogPosts.trigger('heightUpdate.blog-posts');
        }));
        (_a = this.flickity) === null || _a === void 0 ? void 0 : _a.on('cellSelect', () => {
            this.$blogPosts.trigger('heightUpdate.blog-posts');
        });
        this.$blogPosts.on('heightUpdate.blog-posts', () => {
            var _a;
            if (!this.flickity) {
                return;
            }
            $slider.height(Math.ceil((_a = this.flickity) === null || _a === void 0 ? void 0 : _a.maxCellHeight));
        }); // Sets the Slider to the height of the first slide
        this.$blogPosts.trigger('heightUpdate.blog-posts');
    }
}
export class DynamicTwitterFeed_DynamicTwitterFeed {
    constructor(section) {
        this.$el = jQuery(section.el);
        this.settings = section.data;
        this._load();
    }
    _load() {
        this.$window = jQuery(window);
        this.flickity = null;
        this.$content = this.$el.find('[data-twitter-content]');
        this.$wrapper = this.$el.find('[data-twitter-wrapper]');
        this.$tweets = this.$el.find('[data-tweet-content]');
        this.$template = jQuery(this.settings.template);
        const { onboarding, username, retweets, images } = this.settings;
        const locale = this.settings.locale || 'en'; // Activate flickity on mobile
        this._mobileSlider = this._mobileSlider.bind(this);
        Layout.onBreakpointChange(this._mobileSlider);
        this._mobileSlider();
        if (onboarding || !username) {
            return;
        }
        TwitterFetcher.fetch({
            profile: {
                screenName: username,
            },
            maxTweets: 3,
            enableLinks: true,
            showUser: true,
            showTime: true,
            dataOnly: false,
            useEmoji: true,
            showImages: images,
            showRetweet: retweets,
            lang: locale,
            customCallback: (tweets) => this._renderTweets(tweets),
            showInteraction: false,
        });
    }
    /**
     * Unbind events when section is re-drawn
     */
    onSectionUnload() {
        var _a;
        (_a = this.$window) === null || _a === void 0 ? void 0 : _a.off('.twitter');
        this.$content.off('.twitter');
        Layout.offBreakpointChange(this._mobileSlider);
        this._destroyFlickity();
    }
    _initFlickity() {
        this.flickity = new Flickity(this.$content[0], {
            cellSelector: '[data-tweet-content]',
            contain: true,
            freeScroll: true,
            percentPosition: false,
            prevNextButtons: false,
            pageDots: false,
            setGallerySize: false,
        });
        this._bindSlider();
    }
    _destroyFlickity() {
        var _a;
        if (!this.flickity) {
            return;
        }
        (_a = this.flickity) === null || _a === void 0 ? void 0 : _a.destroy();
        this.flickity = null;
    }
    _mobileSlider() {
        // If is Large layout, attempt to destroy flickity
        if (Layout.isGreaterThanBreakpoint('S')) {
            this._destroyFlickity();
            return;
        } // Is XS/S/M, and flickity is init'd -- do nothing
        if (this.flickity) {
            return;
        } // Is XS/S/M, and flickity is not init'd
        this._initFlickity();
    }
    _bindSlider() {
        var _a, _b;
        const $slider = this.$content.find('.flickity-slider');
        (_a = this.$window) === null || _a === void 0 ? void 0 : _a.on('resize.twitter', debounce(() => {
            this.$content.trigger('heightUpdate.twitter');
        }));
        (_b = this.flickity) === null || _b === void 0 ? void 0 : _b.on('cellSelect', () => {
            this.$content.trigger('heightUpdate.twitter');
        });
        this.$content.on('heightUpdate.twitter', () => {
            var _a;
            if (!this.flickity) {
                return;
            }
            $slider.height(Math.ceil((_a = this.flickity) === null || _a === void 0 ? void 0 : _a.maxCellHeight));
        }); // Sets the Slider to the height of the first slide
        this.$content.trigger('heightUpdate.twitter');
    }
    /**
     * Retrieve information about user who tweeted
     *
     * @param el
     * @returns {{$avatar: *, link: *, name, screenName}}
     * @private
     */
    _extractAuthor(el) {
        const $el = jQuery(el);
        const link = $el.find('a').attr('href');
        const name = $el.find('[data-scribe="element:name"]').text();
        const screenName = $el.find('[data-scribe="element:screen_name"]').text();
        const $avatar = $el.find('img');
        return {
            $avatar,
            link,
            name,
            screenName,
        };
    }
    /**
     * Retrieve link to tweet, and when it was tweeted
     *
     * @param el
     * @returns {{link: *, postedAt: *}}
     * @private
     */
    _extractMeta(el) {
        const $el = jQuery(el);
        const link = $el.find('a').attr('href');
        const postedAt = $el.text();
        return {
            link,
            postedAt,
        };
    }
    _extractWrapperClass() {
        const wrapperClass = this.$wrapper.attr('class').match(/tweet--count-\d+$/);
        if (wrapperClass) {
            return wrapperClass[0];
        }
        return '';
    }
    _renderTweets(tweets) {
        const tweetsLength = tweets.length;
        if (!tweets || !tweetsLength)
            return;
        const tweetsArray = [];
        const wrapperClass = `tweet--count-${tweetsLength}`;
        tweets.forEach((tweet) => {
            var _a;
            const $tweet = jQuery(tweet);
            const $template = (_a = this.$template) === null || _a === void 0 ? void 0 : _a.clone();
            const authorInfo = this._extractAuthor($tweet[0]);
            const meta = this._extractMeta($tweet[2]);
            const content = $tweet[1]; // Render header
            $template.find('.tweet--header').attr('href', authorInfo.link);
            $template.find('.tweet--header-image').html(authorInfo.$avatar);
            $template.find('.tweet--header-name').text(authorInfo.name);
            $template.find('.tweet--header-screenname').text(authorInfo.screenName); // Render content
            $template
                .find('.tweet--content')
                .append($tweet[3] ? $tweet[3] : null)
                .append(content); // Render footer
            $template.find('.tweet--footer').attr('href', meta.link).find('.tweet--footer--posted').text(meta.postedAt);
            tweetsArray.push($template);
        });
        this.$wrapper.css('min-height', this.$wrapper.height());
        this.$tweets
            .fadeOut()
            .promise()
            .then(() => {
            this._destroyFlickity();
            this.$tweets.remove();
            this.$content.append(tweetsArray);
            this.$wrapper.removeClass(this._extractWrapperClass()).addClass(wrapperClass).css('min-height', '');
            this.$tweets = this.$el.find('[data-tweet-content]');
            this._mobileSlider();
        });
    }
}
